import { useQuery, gql, type QueryResult } from '@apollo/react-hooks';
import { getUser } from '#/graphql/queries';
import type { GetUserQuery } from '#/graphql/types';

export const GET_USER = gql(getUser);

const useUserQuery = (id?: string) => {
  const query: QueryResult<GetUserQuery> = useQuery(GET_USER, {
    variables: { id },
    fetchPolicy: 'cache-and-network',
  });

  return query;
};

export default useUserQuery;
